import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import Navbar from "../../components/Navbar";
import { useAppDispatch, useAppSelector } from "../../store/store";
import "../../css/chats.css";
import ChatTile from "../../components/chats/ChatTile";
import ChattingSec from "../../components/chats/ChattingSec";
import ChatCard from "../../components/chats/ChatCard";
import {
  useGetChatDetailsMutation,
  useGetChatListMutation,
  useGetChatsMutation,
  useSendChatMessageMutation,
} from "../../store/chatsSlice";
import { isEmpty, isNil, orderBy } from "lodash";
import { ChatSessionsType } from "../../interfaces/chats";
import { InterviewType } from "../../interfaces/user";
import { setInterviews } from "../../reducers/userReducer";
import { useGetInterviewsListingMutation } from "../../store/appSlice";
import ModalChattingSec from "../../components/chats/ModalChattingSec";
import NoMessages from "../../assets/images/no-messages.svg";
import GreenMessage from "../../assets/images/green-int-lines.svg";
import { Skeleton } from "antd";
import { useLocation } from "react-router-dom";

function ChatSec() {
  const [chatList, setChatList] = useState<any>([]);
  const [chatMessages, setChatMessages] = useState<any>([]);
  const [chatDetails, setChatDetails] = useState<any>({});
  const [interviewsListing, setInterviewsListing] = useState<any>({});
  const [isLoading, setLoading] = useState<boolean>(true);
  const [isChatLoading, setChatLoading] = useState<boolean>(true);
  const [isScheduledInterviewLoading, setScheduledInterviewLoading] = useState<boolean>(true);

  const [chatInput, setChatInput] = useState<string>("");
  const [selectedSessionId, setSelectedSessionId] = useState<string>("");
  const [selectedCompanyId, setSelectedCompanyId] = useState<string>("");
  const [chattingModal, setChattingModal] = useState<boolean>(false);
  const [isTapped, setTapped] = useState<boolean>(false);
  const { user } = useAppSelector((state) => state["user"]);
  const [getChatList] = useGetChatListMutation();
  const [getChats] = useGetChatsMutation();
  const [getChatDetails] = useGetChatDetailsMutation();
  const [getInterviewsListing] = useGetInterviewsListingMutation();
  const [sendChatMessage] = useSendChatMessageMutation();
  const dispatch = useAppDispatch();
  const intervalRef = useRef<number | null>(null);
  const previousSelectedSessionId = useRef<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    getDBSessionsData();
    getScheduledInterviews();
  }, []);

  useEffect(() => {
    if (!isEmpty(selectedSessionId)) {
      const intervalId = setInterval(() => {
        console.log("inside");

        getChatsFromDb();
      }, 10000);
      setTapped(false);
      intervalRef.current = intervalId as unknown as number;
    }

    return () => {
      if (!isNil(intervalRef?.current)) {
        clearInterval(intervalRef?.current);
      }
    };
  }, [selectedSessionId]);

  useEffect(() => {
    if (!isEmpty(selectedSessionId) && previousSelectedSessionId.current !== selectedSessionId) {
      getChatsFromDb();
    }
    previousSelectedSessionId.current = selectedSessionId;
  }, [selectedSessionId]);

  const assignDataFromNotification = () => {
    if (!isNil(intervalRef.current)) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setSelectedSessionId(location.state.chatSessionId);
    setSelectedCompanyId(location.state.companyId);
    if (window.innerWidth <= 580) {
      setChattingModal(true);
    }
  };
  const onTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChatInput(e.target.value);
  };

  const getScheduledInterviews = () => {
    getInterviewsListing(user?.id)
      .unwrap()
      .then((interviews: InterviewType) => {
        setInterviewsListing(interviews);
        dispatch(setInterviews(interviews));
        setScheduledInterviewLoading(false);
      })
      .catch((err) => {
        setScheduledInterviewLoading(false);
      });
  };

  const getDBSessionsData = async () => {
    setLoading(true);
    const filterDetails = encodeURIComponent(`
    {



"order": "createdAt DESC",



"fields": {



"id": true,



"companyId": true,



"jobApplicationId": true



},



"include": [{



"relation": "company",



"scope": {



"order": "createdAt",



"fields": {



"id": true,



"companyName": true,



"companyLogo": true



}



}



},



{



"relation": "jobApplication",



"scope": {



"fields": {



"id": true,



"companyJobId": true



},



"include": [{



"relation": "companyJob",



"scope": {



"fields": {



"id": true,



"jobTitle": true



}



}



}]



}



},



{



"relation": "chats",



"scope": {

"include":[{"relation":"interview"}],

"order": "createdAt DESC",
"where": {
"chatType":{"inq":["CHAT","INTERVIEW"]}
},
"limit": "1",
"fields": {
"id": true,

"fromUser": true,

"content": true,



"createdAt": true,



"chatSessionId": true,
"candidate": true



}



}



}



]



}
    `);

    const payload = {
      filterDetails,
      param: user?.id,
    };

    getChatList(payload)
      .unwrap()
      .then((incomingData: ChatSessionsType[]) => {
        const filArray = incomingData?.filter((item: ChatSessionsType) => item.chats);
        const sortedArray = orderBy(
          filArray,
          [(obj) => new Date(obj.chats[0].createdAt)],
          ["desc"]
        );
        if (isEmpty(sortedArray)) {
          setLoading(false);
          return;
        }
        if (!isNil(location?.state) && location?.state?.fromNotification) {
          assignDataFromNotification();
        } else {
          setSelectedCompanyId(sortedArray[0].companyId);
          setSelectedSessionId(sortedArray[0].chats[0].chatSessionId);
        }
        setChatList(sortedArray);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const getChatsFromDb = useCallback(async () => {
    const filterDetails = encodeURIComponent(`
{
 "order": "createdAt DESC",
 "where": {
   "chatType":{"inq":["CHAT","INTERVIEW"]}
 },
  "include": [
    {
      "relation": "interview",
      "scope": {
        "where": {
          "isDeleted": false
        }
      }
    }
  ]
}
`);
    const payload = {
      filterDetails,
      param: selectedSessionId,
    };

    getChats(payload)
      .unwrap()
      .then((incomingData) => {
        const sortedArray = orderBy(incomingData, [(obj) => new Date(obj.createdAt)], ["asc"]);

        setChatMessages(sortedArray);
        getJobDetailsAndCompanyDetails();
      })
      .catch((err) => {
        setLoading(true);
      });
  }, [selectedSessionId]);

  const getJobDetailsAndCompanyDetails = async () => {
    const filterDetails = encodeURIComponent(`
{

 

    "fields": {
        "id": true,
        "jobApplicationId": true
    },
    "include": [{
        "relation": "jobApplication",
        "scope": {
            "fields": {
                "id": true,
                "companyJobId": true
            },
            "include": [{
                "relation": "companyJob",
                "scope": {
                    "fields": {
                        "id": true,
                        "jobTitle": true,
                        "companyId":true
                    },
                    "include": [{
                        "relation": "company",
                        "scope": {
                            "fields": {
                                    "id":true,
                                "companyName": true,
                                "companyLogo": true
                            }
                        }
                    }]
                }

 

 


            }]
        }
    }]
}



`);

    const payload = {
      filterDetails,
      param: selectedSessionId,
    };

    getChatDetails(payload)
      .unwrap()
      .then((incomingData) => {
        setTapped(true);

        setChatLoading(false);
        setLoading(false);

        setChatDetails(incomingData);
      })
      .catch((err) => {});
  };

  const sendMessage = (
    e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (!isEmpty(chatInput.trim())) {
      if (
        e.type === "click" ||
        (e as React.KeyboardEvent<HTMLDivElement>).key === "Enter" // this is called type assertion
      ) {
        let data = {
          fromUser: "CANDIDATE",
          fromUserId: user?.id,
          toUser: "COMPANY",
          toUserId: selectedCompanyId,
          type: "TEXT",
          chatType: "CHAT",
          content: chatInput,
          chatSessionId: selectedSessionId,
        };
        sendChatMessage(data)
          .unwrap()
          .then((incomingData) => {
            setChatInput("");
            let tempMessages = [...chatMessages];
            tempMessages.push(incomingData);
            setChatMessages(tempMessages);
          })
          .catch((err) => {});
      }
    } else {
      setChatInput("");
    }
  };

  const chatsSecContainer = useMemo(
    () => (
      <div className="chatMessagesListContainer">
        <text className="section_heading_text">Chats</text>
        <div className="chatMessagesList">
          {!isEmpty(chatList) ? (
            chatList.map((chat: ChatSessionsType, index: number) => {
              let activeChat = selectedSessionId === chat.chats[0].chatSessionId;
              return (
                <div style={{ marginBottom: "10px" }}>
                  <ChatTile
                    data={chat}
                    activeChat={activeChat}
                    onChatClick={() => {
                      setChatLoading(true);
                      if (!isNil(intervalRef.current)) {
                        clearInterval(intervalRef.current);
                        intervalRef.current = null;
                      }
                      setSelectedSessionId(chat.chats[0].chatSessionId);
                      setSelectedCompanyId(chat.companyId);
                      if (window.innerWidth <= 580) {
                        setChattingModal(true);
                      }
                    }}
                  />
                </div>
              );
            })
          ) : isLoading ? (
            <div style={{ width: "45vh", marginTop: "20px" }}>
              <div className="chat_list_shimmer">
                <Skeleton paragraph={{ rows: 5, width: "90%" }} />
              </div>
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    ),
    [chatList, selectedSessionId, isLoading]
  );

  const emptyDataSec = (errText: string, img: any, isChat: boolean = true) => (
    <div>
      <div className="empty_sec">
        <img
          src={img}
          alt=""
          style={isChat ? {} : { height: "120px", width: "120px", marginTop: "14%" }}
        />
        <text>{errText}</text>
      </div>
    </div>
  );

  return (
    <div>
      <Navbar />
      <div>
        <div className="header_text_container" style={{ marginTop: 70 }}>
          <text className="header_text">Messages</text>
        </div>

        <div className="chat_sec_container">
          <div className="chats_content_sec">
            {chatsSecContainer}

            {!isEmpty(chatList) && (
              <div className="chatting_sec_container">
                <ChattingSec
                  value={chatInput}
                  chatDetails={chatDetails}
                  chatMessages={chatMessages}
                  updateInput={onTextInputChange}
                  sendMessage={sendMessage}
                  refreshList={getChatsFromDb}
                  isChatLoading={isChatLoading}
                />
              </div>
            )}
          </div>
          {isEmpty(chatList) && !isLoading && (
            <div style={{ width: "100%", height: "100vh", marginTop: "7%" }}>
              {emptyDataSec("No Chats Found", NoMessages)}
            </div>
          )}
          <div className="chat_scheduled_interviews">
            <text className="section_heading_text">Scheduled Interviews</text>
            {!isEmpty(interviewsListing) ? (
              interviewsListing.map((chat: InterviewType, index: number) => {
                return (
                  <div style={{ marginBottom: "10px" }}>
                    <ChatCard data={chat} />
                  </div>
                );
              })
            ) : isScheduledInterviewLoading ? (
              <div style={{ width: "45vh", marginTop: "20px" }}>
                <div className="scheduled_interviews_shimmer">
                  <Skeleton paragraph={{ rows: 6, width: "90%" }} />
                </div>
              </div>
            ) : (
              <div style={{ width: "50vh", height: "100vh", marginTop: "17%" }}>
                {emptyDataSec("No Scheduled Interviews Found", GreenMessage, false)}
              </div>
            )}
          </div>
        </div>
      </div>

      {chattingModal && (
        <div className="chatting_sec_modal">
          <ModalChattingSec onCloseModal={() => setChattingModal(false)}>
            <ChattingSec
              value={chatInput}
              chatDetails={chatDetails}
              chatMessages={chatMessages}
              updateInput={onTextInputChange}
              sendMessage={sendMessage}
              refreshList={getChatsFromDb}
              isChatLoading={isChatLoading}
            />
          </ModalChattingSec>
        </div>
      )}

      {/* )} */}
    </div>
  );
}

export default ChatSec;
